import React from 'react';
import { createPortal } from 'react-dom';
import './FormBackButton.css';

// O fade de rota (AnimatedOutlet) anima opacidade num ancestral. No Chrome
// isso prende o `position: fixed`: depois de rolar para baixo e voltar, o
// botão fica desenhado no meio da página e o clique acerta o texto
// embaixo, sem navegar. O rodapé fixo já sai por portal pelo mesmo motivo.
export default function FormBackButton({ onClick, ariaLabel = 'Voltar' }) {
  const button = (
    <button
      type="button"
      className="form-back-button"
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <svg viewBox="0 0 24 24" fill="none" className="form-back-button__icon" aria-hidden="true">
        <polyline
          points="15 18 9 12 15 6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span>Voltar</span>
    </button>
  );

  if (typeof document === 'undefined') return button;
  return createPortal(button, document.body);
}
